export default __webpack_public_path__ + "locales/sr-Latn-RS/Common.json?hash=c09b92e7372fa385d68db9d80c4c3a80";